import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Image as ImageIcon, Play } from "lucide-react";

export const isVideoUrl = (u) => /\.(mp4|mov|webm|avi|m4v)$/i.test(u || "");

export default function NoteMediaGallery({ mediaUrls = [], resolveUrl, testIdPrefix = "note" }) {
  const [lightbox, setLightbox] = useState(null);
  if (!mediaUrls?.length) return null;

  const src = (u) => (resolveUrl ? resolveUrl(u) : u);
  const cols = mediaUrls.length === 1 ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2";

  return (
    <>
      <div className={`mt-3 grid gap-3 ${cols}`}>
        {mediaUrls.map((u, i) => {
          const url = src(u);
          const video = isVideoUrl(u);
          return (
            <div
              key={`${u}-${i}`}
              className="group relative overflow-hidden rounded-xl border border-slate-200/80 bg-slate-50 shadow-sm"
              data-testid={`${testIdPrefix}-media-${i}`}
            >
              {video ? (
                <video
                  src={url}
                  controls
                  playsInline
                  preload="metadata"
                  className="max-h-72 w-full bg-black object-contain"
                />
              ) : (
                <button
                  type="button"
                  onClick={() => setLightbox({ url, index: i })}
                  className="block w-full cursor-zoom-in text-left"
                  aria-label="Görseli büyüt"
                >
                  <img
                    src={url}
                    alt={`Not görseli ${i + 1}`}
                    className="max-h-72 w-full object-contain transition-transform duration-200 group-hover:scale-[1.01]"
                    loading="lazy"
                  />
                  <span className="pointer-events-none absolute bottom-2 right-2 rounded-full bg-black/50 p-1.5 text-white opacity-0 transition-opacity group-hover:opacity-100">
                    <ImageIcon className="h-3.5 w-3.5" />
                  </span>
                </button>
              )}
              {video && (
                <span className="pointer-events-none absolute left-2 top-2 rounded-full bg-black/55 px-2 py-1 text-[10px] font-semibold uppercase tracking-wide text-white">
                  <Play className="mr-1 inline h-3 w-3" />
                  Video
                </span>
              )}
            </div>
          );
        })}
      </div>

      <Dialog open={!!lightbox} onOpenChange={(open) => !open && setLightbox(null)}>
        <DialogContent className="max-w-[min(96vw,900px)] border-none bg-transparent p-2 shadow-none sm:p-4">
          {lightbox && !isVideoUrl(mediaUrls[lightbox.index]) && (
            <img
              src={lightbox.url}
              alt="Not görseli"
              className="max-h-[85vh] w-full rounded-xl object-contain"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
